import Records from '../../modules/records'

export function RecordsPage() {
	return <Records />
}
